import React from 'react'
import { Container} from 'react-bootstrap'
import GoogleMap from '../components/GoogleMap';

const Location = () => {
    return (
        <>
            <Container>
                <div className="min-h-full items-center text-center sm:px-6 lg:px-8 w-full">
                    <h1 className='text-3xl anton text-blue-900 pb-2'>Our Location</h1>
                    <p className="pb-2 text-lg">오시는 길</p>
                    <p className="text-sm">주소 경기도 안양시 동안구 시민대로 230, 지니센터 디동 2265호 (평촌 아크로타워) / E-mail tmk@tmktec.com , tmk1@daum.net , tmkang1@naver.com</p>
                    <div className="pt-5 static"style={{height: '170px'}}>
                        <GoogleMap/>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default Location
